import { initTrialTemplate } from "./trial";

jQuery(async function ($) {
  try {
    const isTrialTemplate = document.querySelector(
      "#ryb-connect #class-finder.template-trials"
    );

    if (isTrialTemplate) {
      await initTrialTemplate();
    }
  } catch (error) {
    console.error("Error initializing templates : ", error);
  }
});
